var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6214 2.91338C12.244 2.29077 13.1008 1.96039 13.9803 2.0038L19.5839 2.28039C21.1853 2.35944 22.4658 3.63993 22.5448 5.24131L22.8214 10.8449C22.8648 11.7244 22.5344 12.5811 21.9118 13.2037L14.3334 20.7822C12.7096 22.4059 10.077 22.4059 8.45318 20.7822L4.04302 16.372C2.41925 14.7482 2.41925 12.1156 4.04302 10.4918L11.6214 2.91338Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3254 6.5H18.3164",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8072 12.2064L10.8256 14M10.8256 14L7.84389 15.7936M10.8256 14L10.8439 17.5M10.8256 14L10.8072 10.5M10.8256 14L13.8252 15.7063M10.8256 14L7.8252 12.2935",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsr1);
export default __webpack_public_path__ + "static/media/gpsr-1.33f535fc92affa1283b21d7df297abb0.svg";
export { ForwardRef as ReactComponent };